import React from "react";
import { Star, ArrowDown } from "lucide-react";
import { LOGO_URL } from "@/data/content";

export default function Hero() {
    return (
        <section
            id="inicio"
            data-testid="hero-section"
            className="relative min-h-screen pt-28 pb-24 overflow-hidden flex items-center"
        >
            {/* Halftone strip top */}
            <div
                aria-hidden
                className="absolute left-0 right-0 top-24 h-10 halftone-dots opacity-40"
            />

            <div className="relative z-10 max-w-[1400px] mx-auto px-5 md:px-10 w-full">
                <div className="grid lg:grid-cols-12 gap-10 items-center">
                    <div className="lg:col-span-7">
                        <div className="inline-flex items-center gap-2 bg-navy text-cream px-4 py-2 border-4 border-navy font-display uppercase text-xs md:text-sm tracking-widest mb-6 hard-shadow-gold">
                            <Star size={14} className="text-gold" />
                            Guadalajara · México · Desde el cosmos creativo
                        </div>

                        <h1
                            data-testid="hero-title"
                            className="font-heading text-navy leading-[0.95] text-5xl sm:text-6xl md:text-7xl lg:text-8xl xl:text-[8.5rem]"
                        >
                            <span className="block">LUNA</span>
                            <span
                                className="block text-orange"
                                style={{ textShadow: "3px 3px 0 #326d8e" }}
                            >
                                MARKAB
                            </span>
                            <span className="block font-display tracking-wider text-3xl md:text-5xl lg:text-6xl text-teal mt-2">
                                PUBLICITARIA
                            </span>
                        </h1>

                        <p
                            data-testid="hero-subtitle"
                            className="mt-8 max-w-xl text-lg md:text-xl text-navy/90 font-medium"
                        >
                            Hacemos que el mundo hable de tu marca. Publicidad
                            de alto impacto, creatividad pura e Inteligencia
                            Artificial para conquistar mercados.
                        </p>

                        <div className="mt-10 flex flex-wrap gap-4">
                            <a
                                href="#contacto"
                                data-testid="hero-cta-primary"
                                className="retro-btn"
                            >
                                Cotizar mi campaña
                            </a>
                            <a
                                href="#servicios"
                                data-testid="hero-cta-secondary"
                                className="retro-btn-gold"
                            >
                                Ver servicios
                            </a>
                        </div>

                        <div className="mt-12 flex items-center gap-6 text-navy/80 font-display uppercase tracking-widest text-xs">
                            <a
                                href="#nosotros"
                                className="flex items-center gap-2 hover:text-orange"
                            >
                                <ArrowDown
                                    size={16}
                                    className="animate-bounce"
                                />
                                Desliza para descubrir
                            </a>
                        </div>
                    </div>

                    {/* Right column with logo + retro frame */}
                    <div className="lg:col-span-5 flex justify-center lg:justify-end">
                        <div className="relative">
                            <div className="relative bg-cream border-[6px] border-navy p-6 md:p-10 hard-shadow-orange animate-floaty">
                                <img
                                    src={LOGO_URL}
                                    alt="Luna Markab"
                                    className="w-[260px] md:w-[340px] h-auto"
                                />
                                <div className="absolute -top-4 -right-4 bg-gold text-navy border-4 border-navy px-3 py-1 font-display uppercase text-xs tracking-widest rotate-6">
                                    Est. 2025
                                </div>
                                <div className="absolute -bottom-5 -left-5 bg-orange text-navy border-4 border-navy px-3 py-1 font-display uppercase text-xs tracking-widest -rotate-3">
                                    Retro · Bold · Real
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}
